document.addEventListener('DOMContentLoaded', function() {
  // Tooltip functionality
  const tooltipTriggers = document.querySelectorAll('[data-tooltip]');
  let activeTooltip = null;
  let tooltipTimeout = null;
  let mouseInTooltip = false; // Track if mouse is inside tooltip
  let closeTime = 0; // Track when tooltip was last closed
  
  // Proper touch device detection instead of unreliable width checking
  const isTouchDevice = (() => {
    if ('ontouchstart' in window) return true;
    if (navigator.maxTouchPoints > 0) return true;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return true;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return true;
    return false;
  })();

  function positionTooltip(tooltip, trigger, position) {
    const triggerRect = trigger.getBoundingClientRect();
    const tooltipWidth = 250; // Fixed tooltip width
    const gap = 12; // Gap between trigger and tooltip
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    let left, top;

    // Calculate horizontal position based on trigger width and position
    if (position === 'left') {
      left = triggerRect.left - tooltipWidth - gap;
    } else if (position === 'right') {
      left = triggerRect.right + gap;
    } else if (position === 'center') {
      left = (triggerRect.left + triggerRect.right) / 2 - tooltipWidth / 2;
    }

    // Calculate vertical position based on tooltip position
    if (position === 'center') {
      // Center tooltips go below the trigger
      top = triggerRect.bottom + gap;
    } else {
      // Left/Right tooltips are vertically centered with the trigger
      top = triggerRect.top + (triggerRect.height / 2);
    }

    // Check if tooltip would go off-screen and adjust position accordingly
    if (left < 10) {
      // Tooltip would go off the left edge
      if (triggerRect.right + tooltipWidth + gap < viewportWidth - 10) {
        // Switch to right position if there's enough space
        position = 'right';
        left = triggerRect.right + gap;
        tooltip.className = tooltip.className.replace('tooltip-left', 'tooltip-right');
      } else if (tooltipWidth <= viewportWidth - 20) {
        // Try center position
        position = 'center';
        left = (triggerRect.left + triggerRect.right) / 2 - tooltipWidth / 2;
        tooltip.className = tooltip.className.replace('tooltip-left', 'tooltip-center');
      } else {
        // If no space on either side, position tooltip to the left but ensure it's visible
        left = 10;
        // Adjust the arrow position by updating the CSS class
        tooltip.className = tooltip.className.replace('tooltip-left', 'tooltip-right');
        position = 'right';
      }
    } else if (left + tooltipWidth > viewportWidth - 10) {
      // Tooltip would go off the right edge
      if (triggerRect.left - tooltipWidth - gap > 10) {
        // Switch to left position if there's enough space
        position = 'left';
        left = triggerRect.left - tooltipWidth - gap;
        tooltip.className = tooltip.className.replace('tooltip-right', 'tooltip-left');
      } else if (tooltipWidth <= viewportWidth - 20) {
        // Try center position
        position = 'center';
        left = (triggerRect.left + triggerRect.right) / 2 - tooltipWidth / 2;
        tooltip.className = tooltip.className.replace('tooltip-right', 'tooltip-center');
      } else {
        // If no space on either side, position tooltip to the right but ensure it's visible
        left = viewportWidth - tooltipWidth - 10;
        // Adjust the arrow position by updating the CSS class
        tooltip.className = tooltip.className.replace('tooltip-right', 'tooltip-left');
        position = 'left';
      }
    }

    // Get tooltip height for bounds checking
    const tooltipHeight = tooltip.offsetHeight || 100; // Fallback height
    
    // Adjust vertical position based on tooltip type and viewport bounds
    if (position === 'center') {
      // Center tooltips: ensure they don't go off bottom of viewport
      if (top + tooltipHeight > viewportHeight - 10) {
        top = viewportHeight - tooltipHeight - 10;
      }
      // Ensure center tooltips don't go above viewport
      if (top < 10) {
        top = 10;
      }
    } else {
      // Left/Right tooltips: adjust for vertical centering with transform
      const halfTooltipHeight = tooltipHeight / 2;
      
      // Check if tooltip would go above viewport when centered
      if (top - halfTooltipHeight < 10) {
        top = 10 + halfTooltipHeight;
      }
      // Check if tooltip would go below viewport when centered
      else if (top + halfTooltipHeight > viewportHeight - 10) {
        top = viewportHeight - 10 - halfTooltipHeight;
      }
    }

    // Final horizontal bounds checking
    if (left < 10) left = 10;
    if (left + tooltipWidth > viewportWidth - 10) left = viewportWidth - tooltipWidth - 10;

    tooltip.style.left = left + 'px';
    tooltip.style.top = top + 'px';
    
    // Apply appropriate transform based on position
    if (position === 'center') {
      tooltip.style.transform = 'none'; // No transform for center tooltips
    } else {
      tooltip.style.transform = 'translateY(-50%)'; // Center left/right tooltips vertically
    }
  }

  function determineArrowPosition(trigger) {
    const triggerRect = trigger.getBoundingClientRect();
    const halfViewportWidth = window.innerWidth/2;

    let position = 'center';

    if (triggerRect.left < 50) {
      position = 'left';
    } else if (triggerRect.left > halfViewportWidth) {
      position = 'right';
    }

    return position;
  }

  function determineTooltipPosition(trigger) {
    const triggerRect = trigger.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const tooltipWidth = 250;
    const gap = 12;
    
    // Calculate available space on both sides
    const spaceOnLeft = triggerRect.left - tooltipWidth - gap;
    const spaceOnRight = viewportWidth - triggerRect.right - tooltipWidth - gap;
    
    // Check if there's enough space on the left (positive value)
    if (spaceOnLeft >= 10) {
      return 'left';
    }
    // Check if there's enough space on the right (positive value)
    else if (spaceOnRight >= 10) {
      return 'right';
    }
    // If both sides have insufficient space, check if we can fit in the center
    else if (tooltipWidth <= viewportWidth - 20) { // 20px for margins
      return 'center';
    }
    // If tooltip is too wide for viewport, choose the side with more space
    else if (spaceOnLeft > spaceOnRight) {
      return 'left';
    } else {
      return 'right';
    }
  }

  function showTooltip(trigger) {
    const tooltipId = trigger.getAttribute('data-tooltip');
    const tooltip = document.getElementById('tooltip-' + tooltipId);
    
    if (!tooltip) return;

    // Hide any existing tooltip
    if (activeTooltip) {
      hideTooltip();
    }
    
    // Reset mouse tracking state for new tooltip
    mouseInTooltip = false;
    closeTime = 0; // Reset close time when intentionally showing tooltip

    const position = determineTooltipPosition(trigger);
    const arrowPosition = determineArrowPosition(trigger);

    // Update tooltip classes and position
    tooltip.className = `tooltip tooltip-${position} arrow-${arrowPosition}`;
    tooltip.style.position = 'fixed';
    tooltip.style.display = 'block';
    
    // Position the tooltip
    positionTooltip(tooltip, trigger, position);
    
    // Show the tooltip with animation
    setTimeout(() => {
      tooltip.classList.add('show');
    }, 10);
    
    activeTooltip = tooltip;
    
    // Add mouse enter/leave events for desktop tooltip closing
    if (!isTouchDevice) {
      tooltip.addEventListener('mouseenter', function() {
        mouseInTooltip = true;
      });
      
      tooltip.addEventListener('mouseleave', function() {
        mouseInTooltip = false;
        // Close tooltip when mouse leaves (only if mouse was inside first)
        hideTooltip();
      });
    }
  }

  function hideTooltip() {
    if (activeTooltip) {
      // Clear any pending hover timeout
      if (tooltipTimeout) {
        clearTimeout(tooltipTimeout);
        tooltipTimeout = null;
      }
      
      activeTooltip.classList.remove('show');

      if (activeTooltip) {
        activeTooltip.style.display = 'none';
        activeTooltip.style.left = '';
        activeTooltip.style.top = '';
        activeTooltip.style.transform = '';
      }
      
      // Reset mouse tracking state
      mouseInTooltip = false;
      closeTime = Date.now(); // Record when tooltip was closed
      activeTooltip = null;      
    }
  }

  // Event listeners for tooltip triggers
  tooltipTriggers.forEach(trigger => {
    // Desktop behavior - hover to open (no auto-close on mouseleave)
    if (!isTouchDevice) {
      trigger.addEventListener('mouseenter', function() {
        // Only open if no tooltip is currently open AND enough time has passed since last close
        const timeSinceClose = Date.now() - closeTime;
        if (!activeTooltip && timeSinceClose > 100) { // 100ms minimum delay after close
          if (tooltipTimeout) {
            clearTimeout(tooltipTimeout);
          }
          tooltipTimeout = setTimeout(() => {
            showTooltip(this);
          }, 300); // Small delay to prevent accidental tooltips
        }
      });
    }

    // Click events for all devices (to close or toggle)
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (activeTooltip && activeTooltip.id === 'tooltip-' + this.getAttribute('data-tooltip')) {
        // If clicking the same trigger, hide the tooltip
        hideTooltip();
      } else {
        // Show the tooltip (this will hide any existing one first)
        showTooltip(this);
      }
    });
  });

  // Close button functionality
  document.addEventListener('click', function(e) {
    if (e.target.closest('.tooltip-close')) {
      e.preventDefault();
      e.stopPropagation();
      hideTooltip();
      return;
    }

    // Hide tooltip when clicking outside (for all devices)
    if (activeTooltip && !activeTooltip.contains(e.target) && !e.target.hasAttribute('data-tooltip')) {
      hideTooltip();
    }
  });

  // Hide tooltip on scroll
  window.addEventListener('scroll', function() {
    if (activeTooltip) {
      hideTooltip();
    }
  });

  // Hide tooltip on window resize
  window.addEventListener('resize', function() {
    if (activeTooltip) {
      hideTooltip();
    }
  });

  document.querySelectorAll('.product').forEach(product => {
    product.addEventListener('mouseleave', function() {
      if (activeTooltip) {
        hideTooltip();
      }
    });
  });
});
